import React from 'react';

const SmsTerms = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">SMS Terms & Conditions</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
            </p>

            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <h2 style={{color: '#1e40af', marginBottom: '1rem'}}>SMS Program Overview</h2>
              <p>
                MEES HOLDINGS INC provides SMS messaging services on behalf of our business clients. By opting in to receive 
                SMS messages, you agree to receive text messages from the business you engaged with, delivered through our 
                messaging platform.
              </p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Program Description</h2>
            <p style={{marginBottom: '1rem'}}>
              Our SMS program allows businesses to send the following types of messages to subscribers who have provided 
              express written consent:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Marketing and promotional offers</li>
              <li>Product updates and announcements</li>
              <li>Order confirmations and shipping notifications</li>
              <li>Appointment reminders and confirmations</li>
              <li>Account notifications and updates</li>
              <li>Customer service communications</li>
              <li>Survey and feedback requests</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>How to Opt-In</h2>
            <p style={{marginBottom: '1rem'}}>
              You can opt-in to receive SMS messages through the following methods:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Website Forms:</strong> Check the SMS opt-in box when submitting contact forms or inquiries</li>
              <li><strong>Online Checkout:</strong> Select SMS notifications during the purchase process</li>
              <li><strong>Text to Join:</strong> Text a keyword (e.g., JOIN, START, SUBSCRIBE) to the provided number</li>
              <li><strong>In-Person Sign-Up:</strong> Provide your phone number and written consent at a business location</li>
              <li><strong>Account Registration:</strong> Opt-in during account creation or profile setup</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Message Frequency</h2>
            <p style={{marginBottom: '2rem'}}>
              Message frequency varies by business and campaign type. You may receive up to 10 messages per month, though 
              frequency may be higher or lower depending on your engagement with the business and the services you've 
              requested. You will be informed of the expected message frequency when you opt-in.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Message & Data Rates</h2>
            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                IMPORTANT: Message and Data Rates May Apply
              </p>
              <p style={{color: '#dc2626', marginBottom: '0'}}>
                Standard messaging rates from your mobile carrier will apply to all SMS messages sent and received. 
                Contact your mobile carrier for details about your messaging plan and any applicable charges. 
                MEES HOLDINGS INC and our business clients are not responsible for carrier charges.
              </p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>How to Opt-Out</h2>
            <p style={{marginBottom: '1rem'}}>
              You can opt-out of receiving SMS messages at any time using any of these methods:
            </p>
            <ul style={{marginBottom: '1rem', paddingLeft: '2rem'}}>
              <li><strong>Text STOP:</strong> Reply STOP, UNSUBSCRIBE, CANCEL, END, or QUIT to any message</li>
              <li><strong>Email:</strong> Send an opt-out request to optout@meesmarketing.com</li>
              <li><strong>Web Form:</strong> Complete the opt-out form at https://meesmarketing.com/opt-out</li>
              <li><strong>Contact Form:</strong> Submit a request through https://meesmarketing.com/contact</li>
              <li><strong>Customer Service:</strong> Contact the business directly to request removal</li>
            </ul>
            <p style={{marginBottom: '2rem'}}>
              After opting out, you will receive a confirmation message and will not receive further marketing messages. 
              You may still receive critical transactional messages related to pending orders or appointments. 
              Opt-out requests are processed within 24 hours.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Help & Support</h2>
            <p style={{marginBottom: '1rem'}}>
              For help with SMS messages, you can:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Text HELP:</strong> Reply HELP, INFO, or SUPPORT to any message for assistance</li>
              <li><strong>Email Support:</strong> support@meesmarketing.com</li>
              <li><strong>Visit Support Page:</strong> https://meesmarketing.com/support</li>
              <li><strong>Contact Form:</strong> https://meesmarketing.com/contact</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Supported Carriers</h2>
            <p style={{marginBottom: '1rem'}}>
              Our SMS program is supported by all major U.S. carriers including:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>AT&T</li>
              <li>T-Mobile</li>
              <li>Verizon Wireless</li>
              <li>Sprint</li>
              <li>Boost Mobile</li>
              <li>Cricket Wireless</li>
              <li>MetroPCS</li>
              <li>U.S. Cellular</li>
              <li>Virgin Mobile</li>
              <li>And other major carriers</li>
            </ul>
            <p style={{marginBottom: '2rem', fontSize: '0.9rem', color: '#6b7280'}}>
              Carriers are not liable for delayed or undelivered messages. Message delivery may be affected by 
              network conditions, device compatibility, or carrier-specific filtering.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Privacy & Data Protection</h2>
            <p style={{marginBottom: '2rem'}}>
              Your mobile phone number and related information are protected under our Privacy Policy. We do NOT 
              sell, rent, or share your mobile number with third parties for marketing purposes. Your information 
              is used solely to deliver the SMS services you've requested. For complete details, please review our 
              Privacy Policy at https://meesmarketing.com/privacy
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Consent Requirements</h2>
            <div style={{background: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>
                Express Written Consent:
              </p>
              <p style={{color: '#1e40af', marginBottom: '1rem'}}>
                By opting in to receive SMS messages, you provide your express written consent to receive automated 
                marketing and transactional text messages from the business you engaged with. Consent is not required 
                as a condition of purchase or service.
              </p>
              <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>
                CTIA Required Disclosure:
              </p>
              <p style={{color: '#1e40af', marginBottom: '0'}}>
                SMS consent is not transferable and will not be sold, shared, or rented to third parties. Your mobile 
                information is used solely for delivering the SMS services you requested.
              </p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>User Responsibilities</h2>
            <p style={{marginBottom: '1rem'}}>
              By participating in our SMS program, you agree to:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Provide accurate and current mobile phone number</li>
              <li>Notify us if your phone number changes</li>
              <li>Ensure you are authorized to receive messages on the provided number</li>
              <li>Maintain a compatible mobile device and active service plan</li>
              <li>Accept responsibility for any carrier charges</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Prohibited Uses</h2>
            <p style={{marginBottom: '1rem'}}>
              You may not use our SMS services to:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Send or request illegal, fraudulent, or harmful content</li>
              <li>Harass, threaten, or abuse others</li>
              <li>Transmit spam or unsolicited messages</li>
              <li>Impersonate others or misrepresent your identity</li>
              <li>Interfere with the proper functioning of the service</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Service Modifications</h2>
            <p style={{marginBottom: '2rem'}}>
              We reserve the right to modify, suspend, or discontinue the SMS program at any time with or without 
              notice. We may also modify these terms and will notify you of material changes through SMS or email.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Disclaimer of Warranties</h2>
            <p style={{marginBottom: '2rem'}}>
              SMS services are provided "as is" without warranties of any kind. We do not guarantee uninterrupted 
              service, timely delivery, or error-free operation. Message delivery depends on carrier networks and 
              device compatibility, which are beyond our control.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Limitation of Liability</h2>
            <p style={{marginBottom: '2rem'}}>
              MEES HOLDINGS INC and our business clients shall not be liable for any damages arising from your use 
              of SMS services, including but not limited to delayed or undelivered messages, carrier charges, or 
              service interruptions.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Governing Law</h2>
            <p style={{marginBottom: '2rem'}}>
              These SMS Terms are governed by the laws of the State of New York and are subject to our general 
              Terms of Service at https://meesmarketing.com/terms
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p><strong>MEES HOLDINGS INC</strong></p>
              <p>2022 E 9TH ST<br />BROOKLYN, NY 11223<br />United States</p>
              <p>Email: support@meesmarketing.com</p>
              <p>Opt-Out: optout@meesmarketing.com</p>
              <p>Website: https://meesmarketing.com</p>
              <p style={{marginTop: '1rem', fontSize: '0.9rem', color: '#6b7280'}}>
                For questions about SMS services, please contact us using any of the methods above.
              </p>
            </div>

            <div style={{background: '#fef9e7', padding: '1.5rem', borderRadius: '8px', marginTop: '2rem', border: '2px solid #f59e0b'}}>
              <h3 style={{color: '#92400e', marginBottom: '1rem'}}>Quick Reference</h3>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>To Opt-Out:</strong> Text STOP to any message</p>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>For Help:</strong> Text HELP to any message</p>
              <p style={{color: '#92400e', marginBottom: '0.5rem'}}><strong>Support Email:</strong> support@meesmarketing.com</p>
              <p style={{color: '#92400e', marginBottom: '0'}}><strong>Message Frequency:</strong> Varies (up to 10/month typically)</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SmsTerms;
